module.exports = __webpack_public_path__ + "media/images/icon-exit-red-97c4d6e2b690c9bc88a674f386c6449d.svg";